<template>
	<div id="cc_right2">
		<div class="cc-header">服务概况
			<div class="title_tab">
				<div class="legend-color" style="background-color: #32ceb7;"></div>服务学生占比
				<div class="legend-color" style="background-color: #ffbe3c;margin-left: 0.1rem;"></div>服务学生数量
			</div>
		</div>
		<div class="main-value" id="partic_pie"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
let pageSize = 6; //echarts每页显示数量
let schoolStudentChart;
export default {
	data() {
		return {
			start: 0,
			end: pageSize - 1,
			total: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1天
		let _this = this;
		setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60 * 24);
		// 定时器轮播，5秒
		setInterval(() => {
			_this.dataZoomAutoScoll();
		}, 1000 * 5);
	},
	methods: {
		//echarts图标数据过多时，x轴自动滑动
		dataZoomAutoScoll() {
			const max = this.total - 1;
			if (pageSize < this.total) {
				if (this.end > max || this.start > max - pageSize) {
					this.start = 0;
					this.end = pageSize - 1;
				} else {
					this.start += 1;
					this.end += 1;
				}
				schoolStudentChart.dispatchAction({
					type: 'dataZoom',
					dataZoomIndex: 0,
					startValue: this.start,
					endValue: this.end
				});
			}
		},
		initData() {
			let _this = this;
			// 基于准备好的dom，初始化echarts实例
			schoolStudentChart = echarts.init(document.getElementById("partic_pie"));
			this.$http.get("/dataView/clubClass/edu/getOrgServeStu?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.total = result.xDatas.length;
					var option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							},
							formatter: function (params) {
								var relVal = params[0].name;
								for (var i = 0; i < params.length; i++) {
									if(params[i].seriesName == '学生数量'){
										relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '人</b>';
									}else{
										relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '%</b>';
									}
								}
								return relVal
							}
						},
						dataZoom: [{
							type: 'inside',
							startValue: _this.start,
							endValue: _this.end,
						}],
						xAxis: [{
							type: 'category',
							scale: true,
							data: result.xDatas,
							boundaryGap: true,
							axisLabel: {
								interval: 0,
								rotate: 25, // 角度
								formatter: function (value) {
									return (value.length > 6 ? (value.slice(0, 6) + "...") : value)
								},
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							}
						}],
						grid: {
							left: "10%",
							top: "15%",
							bottom: "16%",
						},
						yAxis: [
							{
								type: 'value',
								name: '人数',
								nameTextStyle:{
									color:"#ffbe3c"
								},
								splitLine: {
									show: true,
									lineStyle: {
										width: 1,
										color: 'rgba(255, 255, 255, 0.2)',
									}
								},
								axisLabel: {
									textStyle: {
										color: '#ffbe3c',
										fontSize: fontSize(0.12)
									},
									formatter: '{value}'
								},
								axisLine: {
									show: true
								},
							},
							{
								type: 'value',
								name: '占比',
								nameTextStyle:{
									color:"#32ceb7"
								},
								splitLine: {
									show: true,
									lineStyle: {
										width: 1,
										color: 'rgba(255, 255, 255, 0.2)',
									}
								},
								axisLabel: {
									textStyle: {
										color: '#32ceb7',
										fontSize: fontSize(0.12)
									},
									formatter: '{value}%'
								},
								axisLine: {
									show: true
								},
							}
						],
						series: [
							{
								name: '学生数量',
								type: 'line',
								smooth: true,
								areaStyle: {
									opacity: 0.8,
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgb(50, 206, 183,0.1)'
									},
									{
										offset: 1,
										color: 'rgb(50, 206, 183,0.6)'
									}
									])
								},
								data: result.ydatas1,
								itemStyle: {
									//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
									normal: {
										//柱形图圆角，初始化效果
										barBorderRadius: [50],
										color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: "#ffbe3c" // 0% 处的颜色
										}, {
											offset: 1,
											color: "#ffbe3c" // 100% 处的颜色
										}], false)
									}
								},
								yAxisIndex: 0
							},
							{
								name: '学生占比',
								type: 'line',
								smooth: true,
								areaStyle: {
									opacity: 0.8,
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgb(255, 190, 60,0.1)'
									},
									{
										offset: 1,
										color: 'rgb(255, 190, 60,0.6)'
									}
									])
								},
								data: result.ydatas2,
								itemStyle: {
									//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
									normal: {
										//柱形图圆角，初始化效果
										barBorderRadius: [50],
										color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: "#32ceb7" // 0% 处的颜色
										}, {
											offset: 1,
											color: "#32ceb7" // 100% 处的颜色
										}], false)
									}
								},
								yAxisIndex: 1
							}
						]
					};
					schoolStudentChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => schoolStudentChart.resize(), false);
				}
			});
		}
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#cc_right2 {
	height: 100%;

	.cc-header {
		width: 100%;
		text-align: center;
		background: url("../../assets/img/ac_titbgsmall.png") center no-repeat;
		background-size: 100%;
		color: #0ef3ff;
		font-size: 0.22rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;

		.title_tab {
			position: absolute;
			left: 0.3rem;
			top: 0.7rem;
			font-size: 0.18rem;
			height: 0.2rem;
			display: flex;
			align-items: center;

			.legend-color {
				display: inline-block;
				width: 0.25rem;
				height: 0.15rem;
				border-radius: 15%;
				margin-right: 0.05rem;
			}
		}
	}

	.main-value {
		height: 85%;
		padding-left: 1%;
	}

}
</style>